import { keycloak } from "./keycloak";
import { KeycloakToken } from "./keycloakTokenSchema";

/**
 * Get the parsed token from keycloak
 *
 * @returns {KeycloakToken} The parsed token
 */
export function getParsedToken() {
  if (!keycloak.tokenParsed) {
    throw new Error("Token not found");
  }
  return keycloak.tokenParsed as KeycloakToken;
}
